var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfoLightgrey = function SvgInfoLightgrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#266FF2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 13v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.25 12a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 14.5 0Z"
  }))));
};
export { SvgInfoLightgrey as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vT3V0bGluZS8yNHB4L2luZm9ybWF0aW9uIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTEyIDEzVjE1IiBzdHJva2U9IiMyNjZGRjIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgZD0iTTEyLjUgOUMxMi41IDkuMjc2MTQgMTIuMjc2MSA5LjUgMTIgOS41QzExLjcyMzkgOS41IDExLjUgOS4yNzYxNCAxMS41IDlDMTEuNSA4LjcyMzg2IDExLjcyMzkgOC41IDEyIDguNUMxMi4yNzYxIDguNSAxMi41IDguNzIzODYgMTIuNSA5WiIgc3Ryb2tlPSIjMjY2RkYyIi8+CjxwYXRoIGlkPSJWZWN0b3JfMyIgZD0iTTE5LjI1IDEyQzE5LjI1IDE2LjAwNDEgMTYuMDA0MSAxOS4yNSAxMiAxOS4yNUM3Ljk5NTk0IDE5LjI1IDQuNzUgMTYuMDA0MSA0Ljc1IDEyQzQuNzUgNy45OTU5NCA3Ljk5NTk0IDQuNzUgMTIgNC43NUMxNi4wMDQxIDQuNzUgMTkuMjUgNy45OTU5NCAxOS4yNSAxMloiIHN0cm9rZT0iIzI2NkZGMiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo=";